import 'mint-ui/lib/style.css'
import Vue from 'vue'
import App from './App.vue'

import {MessageBox, Toast} from 'mint-ui';
import axios from 'axios'
import {router} from "./router";

import VueContextMenu from 'vue-contextmenu'

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'

import 'default-passive-events'
import 'vant/lib/index.less';

Vue.use(vueMiniPlayer)

Vue.use(VueContextMenu)

Vue.prototype["$messagebox"] = MessageBox
Vue.prototype["$toast"] = Toast

Vue.prototype["$ajax"] = axios

Vue.config.productionTip = false

Vue.prototype.getMachineType = function () {
    let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|UCBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (isMobile)
        return "Mobile"
    else
        return "PC"
}

Vue.prototype.isMobile = function () {
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|UCBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}

//判断是否是微信浏览器 MicroMessenger，QQ:MQQBrowser
Vue.prototype.isWeiXin = function () {
    return /(MicroMessenger)/i.test(navigator.userAgent);
}

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
